import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import StickyTable from "../../components/common/StickyTable";
import { MEETING_SCHEDULE_LIST, MEETING_SCHEDULE, MEETING_STATUS_UPDATE, USER_LIST_DROPDOWN, CHAPTER_LIST_DROPDOWN, REGION_LIST_DROPDOWN } from "../../routes/routes";
import { PAGINATE } from "../../constant/constant";
import { toast } from "react-toastify";
import { NoDataFound, Pagination } from "../../components/Utils";
import Loader from '../../components/common/Loader'; // Import the loader component
import { Modal } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import { Link } from "react-router-dom";


const MeetingSchedulesList = () => {
  // ## State Variable Declaration
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [refresh, setRefresh] = useState(false); // New state to trigger refresh
  const [modal, setModal] = useState(false);
  const [error, setError] = useState("");
  const [meetingId, setMeetingId] = useState();
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const [statusSelected, setStatusSelected] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [filter, setFilter] = useState([]);
  const [userOptions, setUserOptions] = useState({});
  const [showClearBtn, setShowClearBtn] = useState(false);
  const refFlatpickr = useRef(null);
  const selectChapterRef = useRef(null);
  const selectMemberRef = useRef(null);

  const handleChapterClear = () => {
    selectChapterRef.current.clearValue();
    selectMemberRef.current.clearValue();
  };

  const handleMemberClear = () => {
    selectMemberRef.current.clearValue();
  };


  const auth_user = JSON.parse(localStorage.getItem("user"));
  const isSuperAdmin = auth_user?.user_type === 1 ? 1 : 0;
  const isRegionAdmin = auth_user?.user_type === 2 ? 1 : 0;
  const isChapterAdmin = auth_user?.user_type === 3 ? 1 : 0;

  const statusOptions = [
    { value: 0, label: "Upcoming" },
    { value: 1, label: "Attended" },
    { value: 2, label: "Absent" }
  ];

  const handleDateRangeClear = () => {
    setShowClearBtn(false);
    refFlatpickr.current.flatpickr.setDate([]);
    setFilter({
      ...filter,
      from_date: "",
      to_date: "",
    })
  };

  const assignStatus = () => {
    if (status === "") {
      setError("Status is Required");
      return false;
    }
    axios
      .post(MEETING_STATUS_UPDATE + meetingId, { status: status })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setError("");
          setModal(false);
          toast.success(response.data.msg);
          setRefresh((prevRefresh) => !prevRefresh);
        }
      });
  };

  const scheduleMeeting = () => {
    axios
      .get(MEETING_SCHEDULE)
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          toast.success(response.data.msg);
          setRefresh((prevRefresh) => !prevRefresh);
        }
      });
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(MEETING_SCHEDULE_LIST, {
        params: {
          type: PAGINATE,
          page: page,
          perPage: perPage,
          isAdmin: 1,
          ...filter
        }
      })
      .then((response) => {
        if (
          response.status === 200 &&
          response.data.success) {
          setData(response.data.data.schedules);
          setPaginator({
            prev: response.data.data.prev_page_url != null,
            next: response.data.data.next_page_url != null,
            total: response.data.data.total,
            current: response.data.data.current_page,
            last: response.data.data.last_page,
          });
        }
      }).finally(() => {
        setLoading(false); // Set loading to false after data is fetched
      });

    const fetchData = async () => {
      try {
        // Fetch user data
        const region_id = (isRegionAdmin === 1) ? auth_user?.region_id : "";
        const chapter_id = (isChapterAdmin === 1) ? auth_user?.chapter_id : "";

        const userResponse = await axios.get(USER_LIST_DROPDOWN, {
          params: {
            ...filter,
            exclude_other_region_chapter_users: 1,
          }
        });
        const fetchedUserOptions = userResponse.data.data;
        setUserOptions(fetchedUserOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN);
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter
          }
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();

  }, [page, refresh, perPage, filter]);

  const handleCalendarClick = () => {
    if (refFlatpickr.current) {
      refFlatpickr.current.flatpickr.open();
    }
  };

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Meeting Schedules List</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Meeting Schedules List</span></li>
              </ol>
            </div>
            {/* {isSuperAdmin === 1 &&
              <div className="col-lg-6">
                <div className="pt-btn">
                  <button type="button" className="btn rounded-pill btn-primary ibutton" onClick={scheduleMeeting}>
                    Schedule Upcoming Meeting
                  </button>
                </div>
              </div>
            } */}
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="card icard sticky-table-card">
          {/* <div className="card-header">
            <h5>Meeting Schedules List</h5>
          </div> */}
          <div className="container-fluid f_containter">
            <div className="row mb-4">

              {isSuperAdmin === 1 &&
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="region_id">
                      Region
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      name="region_id"
                      isClearable
                      options={regionOptions}
                      onChange={(selected) => {
                        handleChapterClear();
                        setFilter({ ...filter, region_id: selected?.value, chapter_id: null });
                      }}
                    />
                  </div>
                </div>
              }

              {(isSuperAdmin === 1 || isRegionAdmin === 1) &&
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="chapter_id">
                      Chapter
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      ref={selectChapterRef}
                      name="chapter_id"
                      isClearable
                      options={chapterOptions}
                      onChange={(selected) => {
                        handleMemberClear();
                        setFilter({ ...filter, chapter_id: selected?.value })
                      }}
                    />
                  </div>
                </div>
              }

              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="user_id">
                    Member
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    ref={selectMemberRef}
                    name="user_id"
                    isClearable
                    options={userOptions}
                    onChange={(selected) => {
                      setFilter({ ...filter, user_id: selected?.value })
                    }}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="meeting_status">
                    Meeting Status
                  </label>
                  <Select
                    name="meeting_status"
                    isClearable
                    options={statusOptions}
                    onChange={(selected) => setFilter({ ...filter, meeting_status: selected?.value })}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="mb-3 dateRangeDiv">
                  <label className="form-label" htmlFor="meeting_date">
                    Date Range
                  </label>
                  <div className="datepicker_wrapper">
                    <div className="datepicker">
                      <Flatpickr
                        ref={refFlatpickr}
                        className="form-control"
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                          onChange: (selected) => {
                            setShowClearBtn(true);
                            if (selected[0] !== undefined && selected[1] !== undefined && selected[1] !== undefined && selected[1] !== "") {
                              setFilter({
                                ...filter,
                                from_date: selected[0] ? moment(selected[0]).format("YYYY-MM-DD") : "",
                                to_date: selected[1] ? moment(selected[1]).format("YYYY-MM-DD") : "",
                              })
                            }
                          },
                          onClose: (selected) => {
                            if (!selected[1]) {
                              setShowClearBtn(false);
                            }
                          }
                        }}
                        placeholder="Meeting Date Range"
                      />
                      {showClearBtn && (
                        <button
                          className="border-0 clearDateRangeBtn"
                          data-bs-toggle="tooltip"
                          data-bs-offset="0,4"
                          data-bs-placement="top"
                          data-bs-html="true"
                          title="Clear"
                          data-bs-original-title="Clear"
                          onClick={handleDateRangeClear}
                        >
                          <i className="bx bx-x"></i>
                        </button>
                      )}
                    </div>
                    <div className="cal_icon" onClick={handleCalendarClick}>
                      <span className="input-group-text calendar-icon"></span>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
          <StickyTable refreshDeps={[data, loading]}><table className="table table-striped itable">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  {isSuperAdmin === 1 &&
                    <th>Region</th>
                  }
                  {(isSuperAdmin === 1 || isRegionAdmin === 1) &&
                    <th>Chapter</th>
                  }
                  <th>Member</th>
                  <th>Meeting Status</th>
                  <th>Meeting Date</th>
                  <th style={{ textAlign: "center", width: "10%" }}>Action</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="7" />
                ) :
                  data.length > 0 ? (
                    data.map((schedule, i) => (
                      <tr key={i}>
                        <td>{schedule?.sno}</td>
                        {isSuperAdmin === 1 &&
                          <td>{schedule?.region_name}</td>
                        }
                        {(isSuperAdmin === 1 || isRegionAdmin === 1) &&
                          <td>{schedule?.chapter_name}</td>
                        }
                        <td>
                          <span className="table_img pr-2"><img src={schedule?.user_profile_image} alt="icon" /></span>{schedule?.user_name}
                        </td>
                        <td>{schedule?.meeting_status_text}</td>
                        <td>{schedule?.meeting_date}</td>
                        <td style={{ textAlign: "center" }}>
                          <button
                            className="badge bg-label-success me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Change meeting status"
                            data-bs-original-title="Change meeting status"
                            onClick={() => {
                              setMeetingId(schedule?.id);
                              setStatus(schedule?.meeting_status);
                              setModal(true);
                              setStatusSelected({ value: schedule?.meeting_status, label: schedule?.meeting_status_text })
                            }}
                          >
                            <i className="bx bx-edit-alt"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <NoDataFound colspan="7" message="No Data Found" />
                  )}
              </tbody>
            </table>
          </StickyTable>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination paginator={paginator} page={(no) => setPage(no)} perPage={perPage} setPerPage={setPerPage} />
          )}
        </div>
      </div>

      <Modal
        show={modal}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h6 className="modal_title">Meeting Status</h6>
          <div className="row">
            <div className="col-12 mb-3">

              <Select
                options={statusOptions}
                value={statusSelected}
                onChange={(selected) => { setStatus(selected?.value); setStatusSelected(selected); }}
              />
              <span className="text-danger">{error}</span>
            </div>
          </div>
          <div className="text-right">
            <button
              onClick={() => {
                assignStatus();
              }}
              className="btn btn-danger btn-md m-4 igreen_btn"
            >
              Update Status
            </button>
          </div>
        </Modal.Body>
      </Modal>

    </div>
  );
};

export default MeetingSchedulesList;
